"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateStoryLink = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const datatypes_1 = require("../../datatypes");
const CreateStorytIcon_1 = require("../icons/CreateStorytIcon");
const IconLink_1 = require("./IconLink");
/**
 * Link button for creating a story
 */
function CreateStoryLink(props) {
    const CREATE_STORY_ICON_DATA_TEST = "ConsumerNav_CreateStoryIcon";
    return ((0, jsx_runtime_1.jsx)(IconLink_1.IconLink, { href: props.link, title: props.title, label: props.label, onClick: (event) => props.onClick?.(event, datatypes_1.DesktopNavItemType.CREATE_STORY_LINK), dataTest: CREATE_STORY_ICON_DATA_TEST, children: (0, jsx_runtime_1.jsx)(CreateStorytIcon_1.CreateStoryIcon, {}) }));
}
exports.CreateStoryLink = CreateStoryLink;
//# sourceMappingURL=CreateStoryLink.js.map